import { render, staticRenderFns } from "./tabbed-view.vue?vue&type=template&id=14cd96e3&"
import script from "./tabbed-view.vue?vue&type=script&lang=js&"
export * from "./tabbed-view.vue?vue&type=script&lang=js&"
import style0 from "./tabbed-view.vue?vue&type=style&index=0&id=14cd96e3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports